import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.933 10.726c0-1.95 1.552-3.529 3.467-3.529s3.467 1.58 3.467 3.529-1.552 3.528-3.467 3.528-3.467-1.58-3.467-3.528M10.4 12.93c1.197 0 2.167-.987 2.167-2.205 0-1.219-.97-2.206-2.167-2.206h-.079c.06.141.079.29.079.441 0 .974-.777 1.765-1.733 1.765-.15 0-.296-.02-.434-.08v.055c0 1.243.97 2.23 2.167 2.23M5.184 6.773C6.459 5.566 8.212 4.55 10.4 4.55s3.94 1.015 5.216 2.222c1.268 1.196 2.116 2.605 2.517 3.614.089.217.089.46 0 .678-.401.984-1.249 2.393-2.517 3.614-1.275 1.207-3.028 2.222-5.216 2.222s-3.94-1.015-5.216-2.222c-1.268-1.221-2.115-2.63-2.518-3.614a.9.9 0 0 1 0-.678c.403-1.01 1.25-2.418 2.518-3.614m5.216-.899c-1.766 0-3.218.816-4.33 1.866-1.044.987-1.764 2.134-2.131 2.986a9.8 9.8 0 0 0 2.13 2.985c1.113 1.05 2.565 1.867 4.331 1.867s3.218-.816 4.33-1.867c1.043-.987 1.74-2.158 2.132-2.985a10 10 0 0 0-2.131-2.986c-1.113-1.05-2.565-1.866-4.331-1.866"
    }, null, -1)
  ]))]))
}
export default { render: render }